import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isDownloadingMemberAddresses = createSelector(membersState, (members) => members.addresses.isDownloading);
